import type { MultiselectOption } from '@ironsight/types'
import { ref, Ref } from 'vue'

const syncTargetSyncStatusOptions: MultiselectOption[] = [
  {
    label: 'Success',
    value: 'Success',
  },
  {
    label: 'Queued',
    value: 'Queued',
  },
  {
    label: 'Partial Success',
    value: 'PartialSuccess',
  },
  {
    label: 'Failed',
    value: 'Failed',
  },
]

export function useBatchSyncStatusFilterProvider(): {
  options: Ref<MultiselectOption[]>
} {
  const options = ref(syncTargetSyncStatusOptions)
  return { options }
}
